import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchCompany } from "../redux/slices/homeSlice";
import { title } from "process";

const CompanyRap = styled.div`
margin-top: 200px;
  .company-1-left h2 {
    color: #060b13;
    font-size: 40px;
    line-height: 45px;
    font-weight: 800;
    max-width: 455px;
  }
  .company-1-left p {
    color: #363d4f;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    max-width: 453px;
  }
  .circle-company {
    background: #f6f6f6;
    width: 75px;
    height: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .tech-com-div h4 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .tech-com-div p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
    max-width: 252px;
  }
  .tech-com-div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .inner-sub-company {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .sub-comp-left {
    border-top: 0.8px solid #bac0d4b2;
    padding-top: 20px;
  }
  .company-1-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .company-1 {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    gap: 20px;
  }
  .company-right-down-img {
    display: flex;
    gap: 20px;
  }
  .company-right-img {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .company-right-img img {
    border-radius: 15px;
  }
  .sub-home-3 {
    display: flex;
    gap: 30px;
    align-items: center;
  }
  .sub-home-3 img {
    margin: 0px;
  }
  .home-3 {
    margin-top: 60px;
  }
  .home-3 h4 {
    color: #060b13;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .comapny-3 h3 {
    color: #2F2F2F;
    font-size: 40px;
    font-weight: 700;
    text-align: center;

  }
  .company-3-card img {
    width: 74px;
    height: 74px;
  }
  .company-3-card h4 {
    color: #2F2F2F;
    font-size: 20px;
    font-weight: 700;
  }
  .company-3-card p {
    color: #363D4F;
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
    max-width: 290px;
    text-align: center;
  }
  .company-3-card {
    border: 0.8px solid #BAC0D4B2;
    width: 356px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    border-radius: 10px;
  }
  .sub-company-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 50px;
  }
  .comapny-3 {
    margin-top: 100px;
  }
  .comapny-4-left h2 {
    color: #2F2F2F;
    font-size: 40px;
    font-weight: 800;
    line-height: 44px;
  }
  .comapny-4-left p {
    color: #363D4F;
    font-size: 16px;
    font-weight: 400;
    max-width: 405px;
    line-height: 24px;
  }
  .tick-div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tick-div h5 {
    color: #060B13;
    font-size: 16px;
    font-weight: 600;
  }
  .comapny-4-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .company-4-right {
    display: flex;
    gap: 15px;
  }
  .comapny-4 {
    margin: 100px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  @media (max-width: 1200px) {
    .sub-company-3 {
        grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 1024px) {
    .sub-home-3 {
      flex-wrap: wrap;
    }
    .comapny-4  {
        flex-wrap: wrap;
        gap: 40px;
    }
  }
  @media (max-width: 992px) {
.company-1 {
    flex-wrap: wrap;
}
  }
  @media (max-width: 800px) {
    .sub-company-3 {
        grid-template-columns: repeat(1, 1fr);
    }
  }
  @media (max-width: 600px)  {
    .company-4-right {
        flex-wrap: wrap;
    }
  }
  @media (max-width: 550px)  {
    .up-img-1 {
        width: 400px;
    }
    .up-img-2 {
        width: 220px;
    }
  }
  @media (max-width: 400px) {
.company-3-card {
    width: 250px !important;
}
  }
  @media (max-width: 450px)  {
    .up-img-1 {
        width: 300px;
    }
    .up-img-2 {
        width: 120px;
    }
  }
`;

const Company = () => {
   const dispatch = useDispatch();
    const { companyObject, loading } = useSelector((state) => state.content);
    console.log(companyObject);


    const aboutus = companyObject?.data?.aboutus
    const ourValues = companyObject?.data?.our_values
    const ourMission = companyObject?.data?.our_mission
    const partners = companyObject?.data?.partners
    const moreAboutus = companyObject?.data?.more_aboutus

    useEffect(() => {
        dispatch(fetchCompany());
    }, []);


  return (
    <CompanyRap>
      <div className="company-1 containery">
        <div className="company-1-left">
          <h2>{aboutus?.title}</h2>
          <p>
            {aboutus?.content}
          </p>
          <div className="sub-comp-left">
            {moreAboutus?.map((item, index) => (
                <div className="inner-sub-company">
              <div className="circle-company">
                <img src={`https://admin.pluglr.com/${item?.icon}`} alt="" />
              </div>
              <div className="tech-com-div">
                <h4>{item?.title}</h4>
                <p>{item?.content}</p>
              </div>
            </div>
            ))}
          
          </div>
        </div>
        <div className="company-right-img">
          <img className="up-img-1" src={`https://admin.pluglr.com/${aboutus?.banner}`} alt="" />
          <div className="company-right-down-img">
            <img src={`https://admin.pluglr.com/${aboutus?.icon_one}`} alt="" />
            <img className="up-img-2"  src={`https://admin.pluglr.com/${aboutus?.image}`} alt="" />
          </div>
        </div>
      </div>
      <div className="home-3 containery">
        <h4>{partners?.partnerTitle?.title}</h4>
        <div className="sub-home-3">
          {partners?.partnerList?.map((partner, index) => (
            <img key={index} src={`https://admin.pluglr.com/${partner?.image}`} alt="" />
          ))}
          
        </div>
      </div>
      <div className="comapny-3 containery">
        <h3>{ourValues?.valueHeading?.title}</h3>
        <div className="sub-company-3">
          {ourValues?.valueList?.map((value, index) => (
            <div className="company-3-card" key={index}>
                <img src={`https://admin.pluglr.com/${value?.icon}`} alt="" />
                <h4>{value?.title}</h4>
                <p>{value?.content}</p>
            </div>
          ))}
            
        </div>
      </div>
      <div className="comapny-4 containery">
        <div className="comapny-4-left">
            <h2>{ourMission?.title}</h2>
            <p>{ourMission?.content}</p>
            <div className="tick-div">
                <img src="/images/green-tick.png" alt="" />
                <h5>{ourMission?.paragraph_one}</h5>
            </div>
            <div className="tick-div">
                <img src="/images/green-tick.png" alt="" />
                <h5>{ourMission?.paragraph_two}</h5>
            </div>
            <div className="tick-div">
                <img src="/images/green-tick.png" alt="" />
                <h5>  {ourMission?.paragraph_three}</h5>
            </div>
        </div>
        <div className="company-4-right">
            <img src={`https://admin.pluglr.com/${ourMission?.icon_one}`} alt="" />
            <img src={`https://admin.pluglr.com/${ourMission?.icon_two}`} alt="" />

        </div>
      </div>
    </CompanyRap>
  );
};

export default Company;
